import { Course, Semester } from '../../../types/grades';

export function useSemesterHandlers(
  semesters: Semester[],
  setSemesters: (semesters: Semester[]) => void,
  selectedSemesterId: string
) {
  const handleCourseChange = (index: number, updatedCourse: Course) => {
    setSemesters(semesters.map(semester => {
      if (semester.id === selectedSemesterId) {
        const newCourses = [...semester.courses];
        newCourses[index] = updatedCourse;
        return { ...semester, courses: newCourses };
      }
      return semester;
    }));
  };

  const addCourse = () => {
    setSemesters(semesters.map(semester => {
      if (semester.id === selectedSemesterId) {
        return {
          ...semester,
          courses: [...semester.courses, { code: '', credits: 0, grade: '' }]
        };
      }
      return semester;
    }));
  };

  const deleteCourse = (index: number) => {
    setSemesters(semesters.map(semester => {
      if (semester.id === selectedSemesterId) {
        return {
          ...semester,
          courses: semester.courses.filter((_, i) => i !== index)
        };
      }
      return semester;
    }));
  };

  return {
    handleCourseChange,
    addCourse,
    deleteCourse
  };
}